import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import client from "./client";
import API_ENDPOINTS from "../constants/api-endpoints";

type CB = { onSuccess?: (r: any) => void; onError?: (e: any) => void };

export const useClientList = (cid: number, params: any = {}) =>
  useQuery({
    queryKey: [API_ENDPOINTS.CLI_LIST(cid), params],
    queryFn: () => client.get(API_ENDPOINTS.CLI_LIST(cid), { params }),
    select: (r: any) => ({ data: r.data.data as any[], total: r.data.extra?.total ?? 0 }),
    enabled: !!cid,
    refetchOnWindowFocus: false,
  });

export const useClientCreate = (cid: number, cb: CB = {}) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => client.post(API_ENDPOINTS.CLI_CREATE(cid), data),
    onSuccess: (r) => { qc.invalidateQueries({ queryKey: [API_ENDPOINTS.CLI_LIST(cid)] }); cb.onSuccess?.(r); },
    onError: cb.onError,
  });
};

export const useClientUpdate = (cid: number, cb: CB = {}) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => client.post(API_ENDPOINTS.CLI_UPDATE(cid), data),
    onSuccess: (r) => { qc.invalidateQueries({ queryKey: [API_ENDPOINTS.CLI_LIST(cid)] }); cb.onSuccess?.(r); },
    onError: cb.onError,
  });
};

export const useClientDelete = (cid: number, cb: CB = {}) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => client.post(API_ENDPOINTS.CLI_DELETE(cid), { id }),
    onSuccess: (r) => { qc.invalidateQueries({ queryKey: [API_ENDPOINTS.CLI_LIST(cid)] }); cb.onSuccess?.(r); },
    onError: cb.onError,
  });
};
